var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-imovel-denominacao", {
        attrs: {
          required: true,
          imovel: _vm.cadastro.imovel,
          tipoCadastro: "CANCELAMENTO_CLAUSULA_RESOLUTIVA"
        }
      }),
      _c("matricula-titulo-imovel", {
        attrs: {
          imovel: _vm.cadastro.imovel,
          required: true,
          titulo: "Dados da matrícula/título",
          isLiberacao: true
        }
      }),
      _c("app-documentos", {
        attrs: {
          maxSize: 25000,
          "valid-extensions": ["pdf", "rar", "zip"],
          documentos: _vm.cadastro.imovel.documentos,
          tiposDocumentos: _vm.documentos,
          tiposDocumentosObrigatorios: _vm.documentosObrigatorios,
          observer: _vm.observer,
          aba: "Imóvel",
          validateRule: "documentosObrigatorios"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a00b6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a00b6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/maranhao/liberacao/components/Imovel.vue
// module id = null
// module chunks = 